import { call, put, takeEvery } from "redux-saga/effects";
import {
  hideInvoicesListLoader,
  setErrorInvoiceProfile,
  setInvoiceChoice,
  setInvoiceProfile,
  setInvoicesList,
  showInvoicesListLoader,
  setInvoiceProfileLoader,
  setInvoiceMakeLoader,
  setInvoicesFilters,
  setAggregatedStaffData,
  setLoaderAggregatedStaffData,
} from "./actions";
import {
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";
import {
  ADD_INVOICE,
  DELETE_INVOICE,
  GET_INVOICE_CHOICE,
  GET_INVOICE_PROFILE,
  GET_INVOICES_LIST,
  POST_INVOICE_BY_OFFER,
  POST_INVOICE_BY_SALARY,
  UPDATE_INVOICE_PROFILE,
  PATCH_INVOICE,
  GET_INVOICES_FILTER_DATA,
  GET_AGGREGATED_STAFF_DATA,
  ADD_CUSTOM_INVOICE,
} from "./actionTypes";
import {
  deleteInvoice,
  getAggregatedInvoiceStaffData,
  getInvoice,
  getInvoiceChoice,
  getInvoices,
  getInvoicesFilters,
  patchInvoice,
  postCustomInvoice,
  postInvoice,
  postInvoiceOffer,
  postInvoiceSalary,
} from "../../helpers/jwt_helper";

let toCustomDate = ISODate => {
  let date = new Date(ISODate);
  return (
    date.getFullYear() +
    "-" +
    ("0" + (date.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + date.getDate()).slice(-2) +
    " " +
    ("0" + date.getHours()).slice(-2) +
    ":" +
    ("0" + date.getMinutes()).slice(-2) +
    ":" +
    ("0" + date.getSeconds()).slice(-2)
  );
};

function* onGetInvoicesList({ payload: data }) {
  try {
    yield put(showInvoicesListLoader());
    let response = yield call(getInvoices, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
      ...data.date_filters,
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
        description: i.description === "string" ? "" : i.description,
        created: toCustomDate(i.created),
      })),
    };
    yield put(setInvoicesList(response));
    yield put(hideInvoicesListLoader());
  } catch (error) {
    yield put(hideInvoicesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddInvoice({ payload: { data, history } }) {
  try {
    yield put(showInvoicesListLoader());
    yield call(postInvoice, data);
    yield put(hideInvoicesListLoader());
    showSuccessMessage("Invoice has been added");
    history.push(`/invoices`);
  } catch (error) {
    if (typeof error.response.data === "object") {
      for (let [key, value] of Object.entries(error.response.data)) {
        showErrorMessage(getErrorMessage(`${key}: ${value}`));
      }
    } else {
      showErrorMessage(getErrorMessage(error));
    }
    yield put(hideInvoicesListLoader());
  }
}

function* onAddCustomInvoice({ payload: { data, history } }) {
  try {
    yield put(showInvoicesListLoader());
    yield call(postCustomInvoice, data);
    yield put(hideInvoicesListLoader());
    showSuccessMessage("Invoice has been added");
    history.push(`/invoices`);
  } catch (error) {
    if (typeof error.response.data === "object") {
      for (let [key, value] of Object.entries(error.response.data)) {
        showErrorMessage(getErrorMessage(`${key}: ${value}`));
      }
    } else {
      showErrorMessage(getErrorMessage(error));
    }
    yield put(hideInvoicesListLoader());
  }
}

function* onDeleteInvoice({ payload: { id, data } }) {
  try {
    yield put(showInvoicesListLoader());
    yield call(deleteInvoice, id);
    yield call(onGetInvoicesList, { payload: data });
    yield put(hideInvoicesListLoader());
    showSuccessMessage("Campaign format has been deleted");
  } catch (error) {
    yield put(hideInvoicesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetInvoiceProfile({ payload: id }) {
  try {
    yield put(setInvoiceProfileLoader());
    yield put(setErrorInvoiceProfile(false));
    let response = yield call(getInvoice, id);
    yield put(setInvoiceProfile(response));
    yield put(setInvoiceProfileLoader());
  } catch (error) {
    if (getErrorMessage(error) === "Not found.") {
      yield put(setErrorInvoiceProfile(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
    yield put(setInvoiceProfileLoader());
  }
}

function* onUpdateInvoiceProfile({ payload: { id, invoice, data } }) {
  try {
    yield put(showInvoicesListLoader());
    yield call(null, id, {
      name: invoice.name,
      description: invoice.description,
    });
    yield call(null, { payload: data });
    yield put(hideInvoicesListLoader());
    showSuccessMessage("Invoice has been updated");
  } catch (error) {
    yield put(hideInvoicesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetInvoiceChoice() {
  try {
    yield put(showInvoicesListLoader());
    let response = yield call(getInvoiceChoice);
    yield put(setInvoiceChoice(response));
    yield put(hideInvoicesListLoader());
  } catch (error) {
    yield put(hideInvoicesListLoader());
  }
}

function* onPostInvoiceByOffer({ payload: { data, history } }) {
  try {
    yield put(showInvoicesListLoader());
    yield call(postInvoiceOffer, data);
    yield put(hideInvoicesListLoader());
    showSuccessMessage("Invoice by offer has been added");
    history.push(`/invoices`);
  } catch (error) {
    if (typeof error.response.data === "object") {
      for (let [key, value] of Object.entries(error.response.data)) {
        showErrorMessage(getErrorMessage(`${key}: ${value}`));
      }
    } else {
      showErrorMessage(getErrorMessage(error));
    }
    yield put(hideInvoicesListLoader());
  }
}

function* onPostInvoiceBySalary({ payload: { data, history } }) {
  try {

    if (data.bonus_ids.length == 0) {
      delete data.bonus_ids;
    }

    yield put(showInvoicesListLoader());
    yield call(postInvoiceSalary, data);
    yield put(hideInvoicesListLoader());
    showSuccessMessage("Invoice salary has been added");
    history.push(`/invoices`);
  } catch (error) {
    if (typeof error.response.data === "object") {
      for (let [key, value] of Object.entries(error.response.data)) {
        showErrorMessage(getErrorMessage(`${key}: ${value}`));
      }
    } else {
      showErrorMessage(getErrorMessage(error));
    }
    yield put(hideInvoicesListLoader());
  }
}

function* onUpdateInvoice({ payload: { id, data } }) {
  try {
    yield put(setInvoiceMakeLoader());
    let res = yield call(patchInvoice, id, data);
    // let res = yield call(onGetInvoiceProfile, {
    //   payload: id,
    // });
    yield put(setInvoiceProfile(res));
    showSuccessMessage("Invoice status has been updated");
    yield put(setInvoiceMakeLoader());
  } catch (e) {
    yield put(setInvoiceMakeLoader());
    console.log(e);
  }
}

function* onGetInvoicesFilterData({ }) {
  try {
    let res = yield call(getInvoicesFilters);
    res = {
      contractors: res.contractors.map(i => ({
        id: i.id,
        name: i.counterparty_name,
      })),
      bank_account_numbers: res.bank_account_numbers.map(i => ({
        id: i,
        name: i,
      })),
      currencies: res.currencies.map(i => ({
        id: i,
        name: i,
      })),
    };
    yield put(setInvoicesFilters(res));
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
  }
}

function* onGetAggregatedStaffData({ payload: params }) {
  try {
    yield put(setLoaderAggregatedStaffData());

    let res = yield call(getAggregatedInvoiceStaffData, params);
    let data = {
      data: [],
      head: ["Staff", "Bonus", "Salary rate", "Salary"],
      total: {}
    }

    if (res.length > 0) {
      res.map((i, k) => {
        if (i?.name) {
          const { name, bonus, rate, total } = i;
          const updatedObject = { name, bonus, rate, total };
          data.data.push(updatedObject)
        } else {
          for (let [label, val] of Object.entries(i)) {
            if (label == 'sum_bonus') {
              data.total['bonus'] = val;
            } else if (label == 'sum_rate') {
              data.total['rate'] = val;

            } else if (label == 'sum_total') {
              data.total['total'] = val;
            }
          }
        }
      })
    }
    yield put(setAggregatedStaffData(data));
    yield put(setLoaderAggregatedStaffData());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
    yield put(setLoaderAggregatedStaffData());
  }
}

function* invoiceListSaga() {
  yield takeEvery(GET_INVOICES_LIST, onGetInvoicesList);
  yield takeEvery(DELETE_INVOICE, onDeleteInvoice);
  yield takeEvery(ADD_INVOICE, onAddInvoice);
  yield takeEvery(ADD_CUSTOM_INVOICE, onAddCustomInvoice);
  yield takeEvery(GET_INVOICE_PROFILE, onGetInvoiceProfile);
  yield takeEvery(UPDATE_INVOICE_PROFILE, onUpdateInvoiceProfile);
  yield takeEvery(GET_INVOICE_CHOICE, onGetInvoiceChoice);
  yield takeEvery(POST_INVOICE_BY_OFFER, onPostInvoiceByOffer);
  yield takeEvery(POST_INVOICE_BY_SALARY, onPostInvoiceBySalary);
  yield takeEvery(PATCH_INVOICE, onUpdateInvoice);
  yield takeEvery(GET_INVOICES_FILTER_DATA, onGetInvoicesFilterData);
  yield takeEvery(GET_AGGREGATED_STAFF_DATA, onGetAggregatedStaffData)
}

export default invoiceListSaga;